import React from "react";

const Card = ({ date, title, establishment, details = [], info, skills = [], image, links }) => {
  return (
    <li className="card">
      {image && <div className="card-logo">{image}</div>}
      <div className="card-body">
        <div className="card-meta">
          <span className="card-title">{title}</span>
          {establishment.name && establishment.url && (
            <span className="card-org">
              {" · "}
              <a href={establishment.url} target="_blank" rel="noreferrer">
                {establishment.name}
              </a>
            </span>
          )}
          {establishment.name && !establishment.url && (
            <span className="card-org"> · {establishment.name}</span>
          )}
          {date && <span className="card-date"> · {date}</span>}
        </div>

        {info.length > 0 && (
          <p>{info}</p>
        )}

        {details.length > 0 && (
          <ul className="card-details">
            {details.map((el, i) => (
              <li key={i}>{el}</li>
            ))}
          </ul>
        )}

        <div className="card-footer">
          {links.some((l) => l.name) && (
            <div className="card-links">
              {links.map(
                (el, i) =>
                  el.name && (
                    <a key={i} href={el.url} target="_blank" rel="noreferrer">
                      {el.name}
                    </a>
                  )
              )}
            </div>
          )}

          <ul className="card-tags">
            {skills.map((s) => (
              <li key={s}>{s}</li>
            ))}
          </ul>
        </div>
      </div>
    </li >
  );
};

export default Card;
